import React, { Fragment } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { observer } from "mobx-react";
import { SecondaryOrganizationDetailsStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { OrganizationSecondaryDetailsForm } from "../../../../authentication/components/OrganizationSecondaryDetailsForm";
import { useSecondaryOrganizationDetailsController } from "../../hooks/useSecondaryOrganizationDetailsController";
import { OrganizationSignUpHeader } from "../OrganizationSignUpHeader";
import { BackButton } from "./BackButton";

export const SecondaryOrganizationDetailsStep: React.FC<
    StepRenderProps<SecondaryOrganizationDetailsStepValues, IOrganizationSignUpFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const controller = useSecondaryOrganizationDetailsController(values, allValues, update, submit);

    /********* Render *********/

    return (
        <Fragment>
            <OrganizationSignUpHeader />
            <OrganizationSecondaryDetailsForm
                values={controller.values}
                onChange={(patch) => {
                    controller.onChange(patch);
                    update(patch); // sync with Flow
                }}
                onSubmit={controller.onSubmit}
                isSubmitting={controller.isSubmitting}
                error={controller.error}
                fieldErrors={controller.fieldErrors}
            />
            <BackButton
                onClicked={() => controller.onSubmit({ backClicked: true })}
                isSubmitting={controller.isSubmitting}
            />
        </Fragment>
    );
});